import { siteConfig } from '../config/site';

// Utility function to get site configuration
// This can be used in both server and client components
export function getSiteConfig() {
  return siteConfig;
}

// Helper functions for common config access
export function getCompanyInfo() {
  return siteConfig.company;
}

export function getBranding() {
  return siteConfig.branding;
}

export function getNavigation() {
  return siteConfig.navigation;
}

export function getBanner() {
  return siteConfig.banner;
}

export function getSocialLinks() {
  return siteConfig.social;
}

export function getSEO() {
  return siteConfig.seo;
}

export function getTheme() {
  return siteConfig.theme;
}

export function getContent() {
  return siteConfig.content;
}

export function getFeaturedProject() {
  return siteConfig.content.featuredProject;
}

export function getMotion() {
  return siteConfig.motion;
}

export function getLayout() {
  return siteConfig.layout;
}

export function getServices() {
  return siteConfig.services;
}

export function getProjects() {
  return siteConfig.projects;
}

export function getProjectBySlug(slug: string) {
  return siteConfig.projects.find((p) => p.slug === slug && p.enabled)
}

export function getAdjacentProjects(slug: string) {
  const projects = siteConfig.projects.filter((p) => p.enabled)
  const index = projects.findIndex((p) => p.slug === slug)
  if (index === -1) {
    return { prev: undefined, next: undefined }
  }

  const { projectNavigation } = getUI()
  if (projectNavigation.wrapAround) {
    const prev = projects[(index - 1 + projects.length) % projects.length]
    const next = projects[(index + 1) % projects.length]
    return { prev, next }
  }

  const prev = index > 0 ? projects[index - 1] : undefined
  const next = index < projects.length - 1 ? projects[index + 1] : undefined
  return { prev, next }
}

export function getServiceByHref(href: string) {
  return siteConfig.services.find((s) => s.href === href && s.enabled)
}

export function getUI() {
  return siteConfig.ui
}
